import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../FirebaseComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './sub-admin-panel.css';
import emailjs from 'emailjs-com'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSave, faTimes, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Timestamp } from "firebase/firestore";


import {
  CheckCircle,
  XCircle,
  CreditCard,
  ShieldCheck
} from 'lucide-react';
      

function SubAdminPanel() {


  const [activeTab, setActiveTab] = useState('cardVerification'); // Default tab
  const [users, setUsers] = useState([]);

  //specs repair
  const [jobNo, setJobNo] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [issue, setIssue] = useState("");
  const [date, setDate] = useState("");
  const [status, setStatus] = useState("");
  const [searchJobNo, setSearchJobNo] = useState("");
  const [searchName, setSearchName] = useState("");


  const [isSubmitting, setIsSubmitting] = useState(false);

  const [repairs, setRepairs] = useState([]);
  const [loadingRepairs, setLoadingRepairs] = useState(false);

  // 🔹 FILTER STATES (RENAMED)
  const [repairStatusFilter, setRepairStatusFilter] = useState("");
  const [repairYearFilter, setRepairYearFilter] = useState("");
  const [repairMonthFilter, setRepairMonthFilter] = useState("");
  const [repairDateFilter, setRepairDateFilter] = useState("");

  // Filters
  const [filterStatus, setFilterStatus] = useState("");
  const [filterDate, setFilterDate] = useState("");





  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch all the messages from the contacts
 const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        // Create a query that orders by createdAt timestamp (newest first)
        const q = query(
          collection(db, "contactus"), 
          orderBy("createdAt", "desc")
        );
        
        const querySnapshot = await getDocs(q);
        const contactMessages = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          // Format the timestamp for display
          formattedDate: doc.data().createdAt?.toDate().toLocaleString() || 'N/A'
        }));
        
        setMessages(contactMessages);
        setError('');
      } catch (err) {
        console.error("Error fetching messages:", err);
        setError('Failed to load messages. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);





// spectacles repair
const handleSpecsRepairSubmit = async (e) => {
  e.preventDefault();

  // ⛔ Block multiple clicks
  if (isSubmitting) return;

  setIsSubmitting(true);

  try {
    await addDoc(collection(db, "repairspecs"), {
      jobNo,
      name,
      contact,
      issue,
      date,
      status,
      createdAt: serverTimestamp(),
    });

    alert("Specs repair job saved successfully!");

    // Clear form
    setJobNo("");
    setName("");
    setContact("");
    setIssue("");
    setDate("");
    setStatus("");

  } catch (error) {
    console.error("Error saving repair job:", error);
    alert("Failed to save repair job");
  } finally {
    setIsSubmitting(false); // ✅ Re-enable button
  }
};








//view all repair specs

const fetchRepairs = async () => {
  setLoadingRepairs(true);
  try {
    const q = query(
      collection(db, "repairspecs"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const list = snapshot.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setRepairs(list);
  } catch (error) {
    console.error("Error fetching repairs:", error);
  }
  setLoadingRepairs(false);
};

useEffect(() => {
  fetchRepairs();
}, []);

// ===============================
// UPDATE STATUS
// ===============================

const updateRepairStatus = async (id, newStatus) => {
  const updateData = { status: newStatus };

  if (newStatus === "pending" || newStatus === "in progress") {
    updateData.completedDate = "";
    updateData.deliveredDate = "";
  }

  try {
    await updateDoc(doc(db, "repairspecs", id), updateData);

    setRepairs((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, ...updateData } : r
      )
    );
  } catch (error) {
    console.error("Failed to update status:", error);
  }
};

// ===============================
// UPDATE COMPLETED / DELIVERED DATE
// ===============================

const updateRepairDate = async (id, field, value) => {
  try {
    await updateDoc(doc(db, "repairspecs", id), {
      [field]: value,
    });

    setRepairs((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, [field]: value } : r
      )
    );
  } catch (error) {
    console.error("Date update failed:", error);
  }
};

// ===============================
// FILTER + SEARCH LOGIC
// ===============================

const filteredRepairs = repairs.filter((r) => {
  if (!r.date) return false;

  const repairDateObj = new Date(r.date);

  return (
    (!repairStatusFilter || r.status === repairStatusFilter) &&
    (!repairYearFilter ||
      repairDateObj.getFullYear().toString() === repairYearFilter) &&
    (!repairMonthFilter ||
      (repairDateObj.getMonth() + 1)
        .toString()
        .padStart(2, "0") === repairMonthFilter) &&
    (!repairDateFilter || r.date === repairDateFilter) &&
    (!searchJobNo ||
      r.jobNo.toLowerCase().includes(searchJobNo.toLowerCase())) &&
    (!searchName ||
      r.name.toLowerCase().includes(searchName.toLowerCase()))
  );
});





















//loyalty cutomer
const [formData, setFormData] = useState({
  name: '',
  loyaltyNumber: '',
  address: '',
  phone: '',
  email: '',
  password: ''
});

const [submitting, setSubmitting] = useState(false);
const [success, setSuccess] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setError('');

  try {
    // 1. Save data to Firestore
    await addDoc(collection(db, 'loyaltybase'), {
      ...formData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      status: 'active'
    });

    // 2. Send email to the customer
    await emailjs.send('service_tqyzrz1', 'template_t4cwy4h', {
      name: formData.name,
      loyaltyNumber: formData.loyaltyNumber,
      email: formData.email
    }, 'V7GeEtMQ7Wi0eUrRM');

    setSuccess(true);

    // 3. Reset form
    setFormData({
      name: '',
      loyaltyNumber: '',
      address: '',
      phone: '',
      email: '',
      password: ''
    });

    // Hide success message
    setTimeout(() => setSuccess(false), 5000);
  } catch (err) {
    console.error("Error saving or sending email:", err);
    setError('Failed to save data or send email. Please try again.');
  } finally {
    setSubmitting(false);
  }
};







// Fetch all loyalty customers
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  // Fetch all loyalty customers
  useEffect(() => {
    const fetchLoyaltyCustomers = async () => {
      try {
        const q = query(collection(db, "loyaltybase"));
        const querySnapshot = await getDocs(q);
        
        let loyaltyCustomers = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const joinedDate = data.createdAt?.toDate();
          return {
            id: doc.id,
            ...data,
            joinedDate,
            year: joinedDate ? joinedDate.getFullYear() : 'N/A'
          };
        });

        // Sort by loyalty number numerically
        loyaltyCustomers = loyaltyCustomers.sort((a, b) => {
          const numA = parseInt(a.loyaltyNumber.replace(/\D/g, ''), 10);
          const numB = parseInt(b.loyaltyNumber.replace(/\D/g, ''), 10);
          return numA - numB;
        });
        
        setCustomers(loyaltyCustomers);
        setFilteredCustomers(loyaltyCustomers);
        setError('');
      } catch (err) {
        console.error("Error fetching loyalty customers:", err);
        setError('Failed to load customers. Please try again.');
        toast.error('Failed to load customers');
      } finally {
        setLoading(false);
      }
    };

    fetchLoyaltyCustomers();
  }, []);

  // Filter customers based on search term and year filter
  useEffect(() => {
    let result = [...customers];
    
    // Apply search filter
    if (searchTerm.trim() !== '') {
      const term = searchTerm.toLowerCase();
      result = result.filter(customer => 
        customer.name.toLowerCase().includes(term) ||
        customer.phone.includes(searchTerm) ||
        customer.loyaltyNumber.includes(searchTerm)
      );
    }
    
    // Apply year filter
    if (yearFilter) {
      result = result.filter(customer => 
        customer.year === parseInt(yearFilter)
      );
    }
    
    setFilteredCustomers(result);
  }, [searchTerm, yearFilter, customers]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (customer) => {
    setEditingId(customer.id);
    setEditForm({
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      address: customer.address
    });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
  };

  const handleSaveEdit = async () => {
    try {
      await updateDoc(doc(db, "loyaltybase", editingId), editForm);
      
      setCustomers(customers.map(customer => 
        customer.id === editingId ? { ...customer, ...editForm } : customer
      ));
      
      toast.success('Customer updated successfully');
      setEditingId(null);
    } catch (err) {
      console.error("Error updating customer:", err);
      toast.error('Failed to update customer');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    
    try {
      await deleteDoc(doc(db, "loyaltybase", id));
      setCustomers(customers.filter(customer => customer.id !== id));
      toast.success('Customer deleted successfully');
    } catch (err) {
      console.error("Error deleting customer:", err);
      toast.error('Failed to delete customer');
    }
  };

  // Generate year options from data
  const getYearOptions = () => {
    const years = new Set();
    customers.forEach(customer => {
      if (customer.year && customer.year !== 'N/A') {
        years.add(customer.year);
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Sort descending
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };







//add patients
  const [formPatientData, setFormPatientData] = useState({
    name: "",
    gender: "",
    age: "",
    dob: "",
    contact: "",
    address: "",
    prescribedDate: "",
    prescriptionOld: "",
    prescriptionNew: "",
    specialDisease: "",
    followUpDate: "",
    lensType: "",
  });

  const [successMsg, setSuccessMsg] = useState("");

  const handlePatientChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePatientSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "patients"), {
        ...formData,
        createdAt: Timestamp.now(),
      });
      setSuccessMsg("Patient added successfully!");
      setFormData({
        name: "",
        gender: "",
        age: "",
        dob: "",
        contact: "",
        address: "",
        prescribedDate: "",
        prescriptionOld: "",
        prescriptionNew: "",
        specialDisease: "",
        followUpDate: "",
        lensType: "",
      });
    } catch (error) {
      console.error("Error adding patient:", error);
    }
    setLoading(false);
  };



// fetch all patients
const [patients, setPatients] = React.useState([]);
const [editPatientId, setEditPatientId] = React.useState(null);
const [editFormData, setEditFormData] = React.useState({});
const [alertMessage, setAlertMessage] = React.useState(null); // ✅ alert state

// fetch patients from Firestore
React.useEffect(() => {
  const fetchPatients = async () => {
    const snapshot = await getDocs(collection(db, "patients"));
    setPatients(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };
  fetchPatients();
}, []);

// delete handler
const handlePatientDelete = async (id) => {
  if (window.confirm("Are you sure you want to delete this patient?")) {
    await deleteDoc(doc(db, "patients", id));
    setPatients(patients.filter((p) => p.id !== id));
    setAlertMessage({ type: "delete", text: "❌ Patient deleted successfully!" });
    setTimeout(() => setAlertMessage(null), 3000);
  }
};

// edit click
const handlePatientEditClick = (patient) => {
  setEditPatientId(patient.id);
  setEditFormData({ ...patient });
};

// change fields while editing
const handlePatientEditChange = (e) => {
  setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
};

// save edit
const handlePatientSaveEdit = async (e, id) => {
  e.preventDefault();
  await updateDoc(doc(db, "patients", id), editFormData);
  setPatients(
    patients.map((p) => (p.id === id ? { id, ...editFormData } : p))
  );
  setEditPatientId(null);

  // ✅ success alert
  setAlertMessage({ type: "success", text: "✅ Patient updated successfully!" });
  setTimeout(() => setAlertMessage(null), 3000);
};

// cancel edit
const handlePatientCancelEdit = () => {
  setEditPatientId(null);
};






// states for search and filter
const [filterYear, setFilterYear] = React.useState("");
const [filterMonth, setFilterMonth] = React.useState("");

// 🔎 filtered patients based on search + year + month
const filteredPatients = patients.filter((patient) => {
  const nameMatch = patient.name?.toLowerCase().includes(searchTerm.toLowerCase());
  const phoneMatch = patient.contact?.includes(searchTerm);

  // check year & month filter against prescribedDate
  let dateMatch = true;
  if (filterYear || filterMonth) {
    if (patient.prescribedDate) {
      const dateObj = new Date(patient.prescribedDate);
      const year = dateObj.getFullYear().toString();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");

      if (filterYear && year !== filterYear) dateMatch = false;
      if (filterMonth && month !== filterMonth) dateMatch = false;
    } else {
      dateMatch = false;
    }
  }

  return (nameMatch || phoneMatch) && dateMatch;
});























//fetch all the feedbacks

 const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    if (activeTab !== "feedbacks") return;

    const q = query(collection(db, "feedbacks"), orderBy("timestamp", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const feedbackData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFeedbacks(feedbackData);
    });

    return () => unsubscribe();
  }, [activeTab]);






  // create prescription 
const [patient, setPatient] = useState({
    date: "",
    appointmentNo: "",
    name: "",
    age: "",
    dob: "",
    address: "",
    contact: "",
    remark: "",
  });

  const [rx, setRx] = useState({
    hbRx: {
      right: { sph: "", cyl: "", axis: "", add: "" },
      left: { sph: "", cyl: "", axis: "", add: "" },
    },
    rx: {
      right: { sph: "", cyl: "", axis: "", add: "" },
      left: { sph: "", cyl: "", axis: "", add: "" },
    },
  });

  const handlePrescriptionChange = (field, value) => {
    setPatient({ ...patient, [field]: value });
  };

  const handleRxChange = (section, eye, field, value) => {
    setRx((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [eye]: {
          ...prev[section][eye],
          [field]: value,
        },
      },
    }));
  };




 
  /* ================= PDF ================= */
const generatePDF = () => {
  const doc = new jsPDF();

  // Load fonts - using Roboto for professional look
  doc.setFont("helvetica", "normal");

  // Add logo if available
  try {
    const logo = new Image();
    logo.src = '/optical-logo.png';
    doc.addImage(logo, 'PNG', 14, 10, 40, 40);
  } catch (e) {
    console.log("Logo not found, continuing without it");
  }

  // Company Header with better typography
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("EYE CARE CLINIC & OPTICAL", 65, 20);
  
  doc.setFontSize(11);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(0, 102, 204); // Blue color for tagline
  doc.text("Our Mission, Your Vision", 65, 27);
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0); // Reset to black
  doc.text("932, Maradana Road, Colombo 08", 65, 34);
  doc.text("Phone: 011 268 2277 | 076 136 0944", 65, 39);
  doc.text("Email: eyecareoptical2024@gmail.com", 65, 44);

  // Decorative line
  doc.setDrawColor(0, 102, 204); // Blue line
  doc.setLineWidth(0.5);
  doc.line(14, 50, 196, 50);

  // Patient Information Section
doc.setFontSize(14);
doc.setFont("helvetica", "bold");
doc.setTextColor(51, 51, 51);
doc.text("PATIENT INFORMATION", 14, 60);

// Define column positions
const leftLabelX = 14;
const leftDataX = 50; // Fixed position for all data after labels
const rightLabelX = 120;
const rightDataX = 155; // Fixed position for all data after labels in right column

doc.setFontSize(10);

// Left column - Labels
doc.setFont("helvetica", "bold");
doc.text("Date:", leftLabelX, 70);
doc.text("Name:", leftLabelX, 76);
doc.text("Date of Birth:", leftLabelX, 82);
doc.text("Address:", leftLabelX, 88);

// Left column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.date, leftDataX, 70);
doc.text(patient.name, leftDataX, 76);
doc.text(patient.dob, leftDataX, 82);

// Address with word wrap - also aligned at same position
const addressLines = doc.splitTextToSize(patient.address, 80);
doc.text(addressLines, leftDataX, 88);

// Right column - Labels
doc.setFont("helvetica", "bold");
doc.text("Appointment No:", rightLabelX, 70);
doc.text("Age:", rightLabelX, 76);
doc.text("Contact No:", rightLabelX, 82);

// Right column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.appointmentNo, rightDataX, 70);
doc.text(patient.age, rightDataX, 76);
doc.text(patient.contact, rightDataX, 82);






  // Helper function for prescription tables
  const renderRx = (title, data, startY) => {
    // Section title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(63, 63, 149); // Blue title
    doc.text(title, 14, startY);

    // Table header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255); // White text
    doc.setFillColor(63, 63, 149); // Blue background
    doc.rect(14, startY + 5, 180, 8, 'F');
    
    doc.text("Eye", 20, startY + 10);
    doc.text("SPH", 55, startY + 10);
    doc.text("CYL", 90, startY + 10);
    doc.text("Axis", 125, startY + 10);
    doc.text("Add", 160, startY + 10);

    // Table rows
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(245, 245, 245); // Light gray for alternate rows

    // Right eye row
    doc.rect(14, startY + 13, 180, 8, 'F');
    doc.text("Right (OD)", 20, startY + 18);
    doc.text(data.right.sph || "-", 55, startY + 18);
    doc.text(data.right.cyl || "-", 90, startY + 18);
    doc.text(data.right.axis || "-", 125, startY + 18);
    doc.text(data.right.add || "-", 160, startY + 18);

    // Left eye row
    doc.setFillColor(255, 255, 255); // White for second row
    doc.rect(14, startY + 21, 180, 8, 'F');
    doc.text("Left (OS)", 20, startY + 26);
    doc.text(data.left.sph || "-", 55, startY + 26);
    doc.text(data.left.cyl || "-", 90, startY + 26);
    doc.text(data.left.axis || "-", 125, startY + 26);
    doc.text(data.left.add || "-", 160, startY + 26);

    return startY + 35;
  };

  // Render both prescriptions
  let currentY = 110;
  currentY = renderRx("Hb RX", rx.hbRx, currentY);
  renderRx("RX", rx.rx, currentY);


  doc.setFontSize(10);
  doc.setFont("helvetica", "italic");
  doc.text(`Remarks: ${patient.remark || 'N/A'}`, 14, currentY + 50);

  // Footer with timestamp
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(128, 128, 128);
  const timestamp = new Date().toLocaleString();
  doc.text(`Generated: ${timestamp}`, 14, 280);
  doc.text("Eye Care Clinic & Optical", 105, 280, null, null, "center");

  // Save PDF
  doc.save(`Prescription_${patient.name.replace(/\s+/g, '_')}_${patient.appointmentNo}.pdf`);
};




const savePrescription = async () => {
  try {
    // Save to database
    await addDoc(collection(db, "prescriptions"), {
      patient,
      ...rx,
      createdAt: Timestamp.now(),
    });

    // Generate and download PDF
    generatePDF();
    
    // Show success message
    alert("Prescription saved successfully! PDF download has started.");
    
  } catch (error) {
    console.error("Error saving prescription:", error);
    alert("Error saving prescription. Please try again.");
  }
};


////////////////////////////////////////// view prescription ///////////////////////////////////////////////////////

  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const fetchPrescriptions = async () => {
    const q = query(
      collection(db, "prescriptions"),
      orderBy("createdAt", "desc") 
    );

    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setPrescriptions(data);
  };

  const handlePrescriptionDelete = async (id) => {
    if (!window.confirm("Delete this prescription?")) return;

    await deleteDoc(doc(db, "prescriptions", id));
    fetchPrescriptions();
  };


const generatePrescriptionPDF = (patient, rx) => {
 const doc = new jsPDF();

  // Load fonts - using Roboto for professional look
  doc.setFont("helvetica", "normal");

  // Add logo if available
  try {
    const logo = new Image();
    logo.src = '/optical-logo.png';
    doc.addImage(logo, 'PNG', 14, 10, 40, 40);
  } catch (e) {
    console.log("Logo not found, continuing without it");
  }

  // Company Header with better typography
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("EYE CARE CLINIC & OPTICAL", 65, 20);
  
  doc.setFontSize(11);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(0, 102, 204); // Blue color for tagline
  doc.text("Our Mission, Your Vision", 65, 27);
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0); // Reset to black
  doc.text("932, Maradana Road, Colombo 08", 65, 34);
  doc.text("Phone: 011 268 2277 | 076 136 0944", 65, 39);
  doc.text("Email: eyecareoptical2024@gmail.com", 65, 44);

  // Decorative line
  doc.setDrawColor(0, 102, 204); // Blue line
  doc.setLineWidth(0.5);
  doc.line(14, 50, 196, 50);

  // Patient Information Section
doc.setFontSize(14);
doc.setFont("helvetica", "bold");
doc.setTextColor(51, 51, 51);
doc.text("PATIENT INFORMATION", 14, 60);

// Define column positions
const leftLabelX = 14;
const leftDataX = 50; // Fixed position for all data after labels
const rightLabelX = 120;
const rightDataX = 155; // Fixed position for all data after labels in right column

doc.setFontSize(10);

// Left column - Labels
doc.setFont("helvetica", "bold");
doc.text("Date:", leftLabelX, 70);
doc.text("Name:", leftLabelX, 76);
doc.text("Date of Birth:", leftLabelX, 82);
doc.text("Address:", leftLabelX, 88);

// Left column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.date, leftDataX, 70);
doc.text(patient.name, leftDataX, 76);
doc.text(patient.dob, leftDataX, 82);

// Address with word wrap - also aligned at same position
const addressLines = doc.splitTextToSize(patient.address, 80);
doc.text(addressLines, leftDataX, 88);

// Right column - Labels
doc.setFont("helvetica", "bold");
doc.text("Appointment No:", rightLabelX, 70);
doc.text("Age:", rightLabelX, 76);
doc.text("Contact No:", rightLabelX, 82);

// Right column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.appointmentNo, rightDataX, 70);
doc.text(patient.age, rightDataX, 76);
doc.text(patient.contact, rightDataX, 82);






  // Helper function for prescription tables
  const renderRx = (title, data, startY) => {
    // Section title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(63, 63, 149); // Blue title
    doc.text(title, 14, startY);

    // Table header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255); // White text
    doc.setFillColor(63, 63, 149); // Blue background
    doc.rect(14, startY + 5, 180, 8, 'F');
    
    doc.text("Eye", 20, startY + 10);
    doc.text("SPH", 55, startY + 10);
    doc.text("CYL", 90, startY + 10);
    doc.text("Axis", 125, startY + 10);
    doc.text("Add", 160, startY + 10);

    // Table rows
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(245, 245, 245); // Light gray for alternate rows

    // Right eye row
    doc.rect(14, startY + 13, 180, 8, 'F');
    doc.text("Right (OD)", 20, startY + 18);
    doc.text(data.right.sph || "-", 55, startY + 18);
    doc.text(data.right.cyl || "-", 90, startY + 18);
    doc.text(data.right.axis || "-", 125, startY + 18);
    doc.text(data.right.add || "-", 160, startY + 18);

    // Left eye row
    doc.setFillColor(255, 255, 255); // White for second row
    doc.rect(14, startY + 21, 180, 8, 'F');
    doc.text("Left (OS)", 20, startY + 26);
    doc.text(data.left.sph || "-", 55, startY + 26);
    doc.text(data.left.cyl || "-", 90, startY + 26);
    doc.text(data.left.axis || "-", 125, startY + 26);
    doc.text(data.left.add || "-", 160, startY + 26);

    return startY + 35;
  };

  // Render both prescriptions
  let currentY = 110;
  currentY = renderRx("Hb RX", rx.hbRx, currentY);
  renderRx("RX", rx.rx, currentY);


  doc.setFontSize(10);
  doc.setFont("helvetica", "italic");
  doc.text(`Remarks: ${patient.remark || 'N/A'}`, 14, currentY + 50);

  // Footer with timestamp
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(128, 128, 128);
  const timestamp = new Date().toLocaleString();
  doc.text(`Generated: ${timestamp}`, 14, 280);
  doc.text("Eye Care Clinic & Optical", 105, 280, null, null, "center");

  // Save PDF
  doc.save(`Prescription_${patient.name.replace(/\s+/g, '_')}_${patient.appointmentNo}.pdf`);
};











const [claim, setClaim] = useState({
  jobNo: "",
  name: "",
  phone: "",
  age: "",
  prescriptionDate: "",
  referredBy: "",
  pd: "",
  sh: "",
  rightEyePower: "",
  leftEyePower: "",
  lensModel: "",
  frame: "",
  lensPrice: "",
  framePrice: ""
});

const handleClaimBillChange = (e) => {
  setClaim({ ...claim, [e.target.name]: e.target.value });
};

const saveClaimBill = async () => {
  const total =
    Number(claim.lensPrice || 0) + Number(claim.framePrice || 0);

  await addDoc(collection(db, "claimbill"), {
    ...claim,
    total,
    createdAt: Timestamp.now()
  });

  generateClaimBillPDF({ ...claim, total });
};





const generateClaimBillPDF = (data) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  // Professional color palette
  const NAVY = [0, 32, 64];          // Dark navy for headers
  const GRAY_DARK = [80, 80, 80];     // Dark gray for text
  const GRAY_LIGHT = [240, 240, 240]; // Light gray for backgrounds
  const WHITE = [255, 255, 255];
  
  const MARGIN = 20;
  const PAGE_WIDTH = 210;
  const CONTENT_WIDTH = PAGE_WIDTH - (MARGIN * 2);
  
  /* ========== HEADER ========== */
  
  // Logo on left
  try {
    doc.addImage('/optical-logo.png', 'PNG', MARGIN, 10, 25, 25);
  } catch (error) {
    // If logo fails, use text
    doc.setFontSize(16);
    doc.setTextColor(...NAVY);
    doc.setFont("helvetica", "bold");
    doc.text("EYE CARE CLINIC", MARGIN, 22);
  }
  


// Colors (NO SPREAD — SAFE)
const NAVY_R = 0, NAVY_G = 51, NAVY_B = 102;
const GRAY_R = 80, GRAY_G = 80, GRAY_B = 80;

// ===== LOGO (optional) =====
// If you have logo base64
// doc.addImage(logoBase64, "PNG", MARGIN, 12, 20, 20);

// ===== PRACTICE NAME (LEFT, NEXT TO LOGO) =====
doc.setFont("helvetica", "bold");
doc.setFontSize(16);
doc.setTextColor(NAVY_R, NAVY_G, NAVY_B);
doc.text(
  "EYE CARE CLINIC & OPTICAL",
  MARGIN + 30, // space for logo
  22
);

// ===== PRACTICE DETAILS (RIGHT ALIGNED) =====
doc.setFont("helvetica", "normal");
doc.setFontSize(9);
doc.setTextColor(GRAY_R, GRAY_G, GRAY_B);

doc.text(
  "932, Maradana Road, Colombo 08",
  PAGE_WIDTH - MARGIN,
  15,
  { align: "right" }
);

doc.text(
  "Tel: 011 268 2277",
  PAGE_WIDTH - MARGIN,
  21,
  { align: "right" }
);

doc.text(
  "Email: info@eyecare.lk",
  PAGE_WIDTH - MARGIN,
  27,
  { align: "right" }
);

// ===== DIVIDER LINE =====
doc.setDrawColor(NAVY_R, NAVY_G, NAVY_B);
doc.line(MARGIN, 32, PAGE_WIDTH - MARGIN, 32);
  
  // Separator line
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.5);
  doc.line(MARGIN, 35, PAGE_WIDTH - MARGIN, 35);
  
  /* ========== TITLE AND JOB INFO ========== */
  

  
  // Job details box - clean and minimal
  doc.setFillColor(...GRAY_LIGHT);
  doc.roundedRect(PAGE_WIDTH - MARGIN - 85, 40, 85, 20, 2, 2, 'F');
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Job Number:", PAGE_WIDTH - MARGIN - 80, 50);
  
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`${data.jobNo || 'N/A'}`, PAGE_WIDTH - MARGIN - 25, 50, { align: "right" });
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text(`Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`, PAGE_WIDTH - MARGIN - 80, 57);
  
  /* ========== PATIENT DETAILS ========== */
  
  let y = 70;
  
  // Patient section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("PATIENT INFORMATION", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 50, y + 1);
  
  y += 10;
  
  // Patient details in clean grid with proper alignment
  doc.setFontSize(10);
  doc.setTextColor(...GRAY_DARK);
  
  const col1 = MARGIN;
  const col2 = MARGIN + 95;
  const col3 = MARGIN + 145;
  
  // Row 1
  doc.setFont("helvetica", "bold");
  doc.text("Full Name:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.name || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("Age:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.age || "-", col2 + 15, y);
  
  
  y += 8;
  
  // Row 2
  doc.setFont("helvetica", "bold");
  doc.text("Phone:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.phone || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("Prescription Date:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.prescriptionDate || "-", col2 + 40, y);
  
  y += 8;
  
  // Row 3
  doc.setFont("helvetica", "bold");
  doc.text("Referred By:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.referredBy || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("PD / SH:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(`${data.pd || '-'} / ${data.sh || '-'}`, col2 + 25, y);
  
  y += 15;
  
  /* ========== PRESCRIPTION TABLE ========== */
  
  // Section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("PRESCRIPTION DETAILS", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
  
  y += 10;
  
  // Table headers
  const tableStart = MARGIN;
  const tableWidth = CONTENT_WIDTH;
  const colPrescription = [tableStart, tableStart + 70, tableStart + 130];
  
  // Header background
  doc.setFillColor(...NAVY);
  doc.rect(tableStart, y - 5, tableWidth, 8, 'F');
  
  doc.setTextColor(...WHITE);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("Description", colPrescription[0] + 2, y);
  doc.text("Right Eye", colPrescription[1] + 2, y);
  doc.text("Left Eye", colPrescription[2] + 2, y);
  
  y += 8;
  
  // Table rows
  doc.setTextColor(...GRAY_DARK);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  
  const rows = [
    ["Eye Power", data.rightEyePower || "-", data.leftEyePower || "-"],
    ["Lens Model", data.lensModel || "-", ""],
    ["Frame", data.frame || "-", ""]
  ];
  
  rows.forEach((row, index) => {
    // Light gray background for alternate rows
    if (index % 2 === 1) {
      doc.setFillColor(...GRAY_LIGHT);
      doc.rect(tableStart, y - 4, tableWidth, 6, 'F');
    }
    
    doc.text(row[0], colPrescription[0] + 2, y);
    doc.text(row[1], colPrescription[1] + 2, y);
    doc.text(row[2], colPrescription[2] + 2, y);
    y += 7;
  });
  
  y += 10;
  
  /* ========== CHARGES SECTION ========== */
  
  // Section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("CHARGES BREAKDOWN", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
  
  y += 10;
  
  // Charges table with proper alignment
  const chargesLeft = MARGIN;
  const chargesRight = PAGE_WIDTH - MARGIN;
  const lineLength = 80;
  
  // Lens price row
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Lens Price:", chargesLeft, y);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`Rs. ${Number(data.lensPrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 8;
  
  // Frame price row
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Frame Price:", chargesLeft, y);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`Rs. ${Number(data.framePrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 8;
  
  // Subtotal line (if needed)
  if (data.discount) {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...GRAY_DARK);
    doc.text("Subtotal:", chargesLeft, y);
    const subtotal = (Number(data.lensPrice) + Number(data.framePrice)).toLocaleString();
    doc.text(`Rs. ${subtotal}`, chargesRight - 5, y, { align: "right" });
    y += 8;
    
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...GRAY_DARK);
    doc.text("Discount:", chargesLeft, y);
    doc.text(`- Rs. ${Number(data.discount).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
    y += 8;
  }
  
  // Separator line
  doc.setDrawColor(...GRAY_DARK);
  doc.setLineWidth(0.2);
  doc.line(chargesRight - lineLength, y - 2, chargesRight, y - 2);
  
  y += 5;
  
  // Total
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("TOTAL AMOUNT:", chargesLeft, y);
  doc.text(`Rs. ${Number(data.total || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 6;

  
  /* ========== FOOTER ========== */
  
  // Footer line
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.5);
  doc.line(MARGIN, 250, PAGE_WIDTH - MARGIN, 250);
  
  // Footer content - three column layout
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  
  // Left - Generated info
  doc.text(`Generated: ${new Date().toLocaleString()}`, MARGIN, 260);
  
  // Center - Thank you message
  doc.setFont("helvetica", "italic");
  doc.text("Thank you for choosing Eye Care Clinic", PAGE_WIDTH / 2, 260, { align: "center" });
  

  
  /* ========== TERMS ========== */
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  
  // Add page number
  doc.text("Page 1 of 1", PAGE_WIDTH / 2, 280, { align: "center" });
  
  doc.save(`Claim_Bill_${data.jobNo || 'New'}.pdf`);
};


















// view all claim bill
  const [bills, setBills] = useState([]);


  useEffect(() => {
    const fetchBills = async () => {
      try {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "claimbill"));
        
        const billsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setBills(billsList);
        setError(null);
      } catch (err) {
        console.error("Error fetching bills:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBills();
  }, []);










/////////////////////////////////////////// fetch membership submission

  const [memberships, setMemberships] = React.useState([]);

  React.useEffect(() => {
    const fetchMemberships = async () => {
      try {
        const ref = collection(db, "optica-memberships");
        const snapshot = await getDocs(ref);

        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setMemberships(list);
      } catch (err) {
        console.error("Error fetching memberships:", err);
      }
    };

    fetchMemberships();
  }, []);









  const [cardNumber, setCardNumber] = useState('');
  const [cardMonth, setCardMonth] = useState('');
  const [cardYear, setCardYear] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSaveCard = async (e) => {
    e.preventDefault();

    try {
      setErrorMessage('');
      setSuccessMessage('');

      await addDoc(collection(db, 'card_verification'), {
        cardNumber,
        cardMonth,
        cardYear,
        createdAt: serverTimestamp(),
      });

      setSuccessMessage('Customer card added successfully');

      // Clear form
      setCardNumber('');
      setCardMonth('');
      setCardYear('');

    } catch (error) {
      console.error('Error saving card:', error);
      setErrorMessage('Failed to save customer card');
    }
  };








  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  // Fetch Cards
  useEffect(() => {

    const q = query(
      collection(db, 'card_verification'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {

      const cardList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCards(cardList);
      setFilteredCards(cardList);
    });

    return () => unsubscribe();

  }, []);

  // Filter Logic
  useEffect(() => {

    let filtered = [...cards];

    if (selectedMonth) {
      filtered = filtered.filter(
        (card) => card.cardMonth === selectedMonth
      );
    }

    if (selectedYear) {
      filtered = filtered.filter(
        (card) => card.cardYear === selectedYear
      );
    }

    setFilteredCards(filtered);

  }, [selectedMonth, selectedYear, cards]);


////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const [verificationResult, setVerificationResult] = useState(null);


  const handleVerifyCard = async (e) => {
    e.preventDefault();

    if (!cardNumber.trim()) return;

    try {

      setLoading(true);
      setVerificationResult(null);

      const q = query(
        collection(db, 'card_verification'),
        where('cardNumber', '==', cardNumber)
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {

        const cardData = querySnapshot.docs[0].data();

        setVerificationResult({
          status: 'verified',
          data: cardData
        });

      } else {

        setVerificationResult({
          status: 'not_found'
        });

      }

    } catch (error) {

      console.error('Verification Error:', error);

      setVerificationResult({
        status: 'error'
      });

    } finally {
      setLoading(false);
    }
  };














  return (
    <div className="admin-panel">
<div className="top-navigation">

  <ul className="tabs">

    <li
      className={`tab ${activeTab === 'cardVerification' ? 'active' : ''}`}
      onClick={() => handleTabClick('cardVerification')}
    >
      Card Verification System
    </li>

  </ul>

  <button className="logout-btn" onClick={handleLogout}>
    Logout
  </button>

</div>

      <div className="main-content">


{/************************* Card Verification System ********************************/}


 {activeTab === "cardVerification" && (

        <div className="card-verification-container">

          <div className="card-verification-card">

            {/* Header */}
            <div className="verification-header">

              <div className="verification-icon">
                <ShieldCheck size={38} />
              </div>

              <h2>Card Verification System</h2>

              <p>
                Verify customer card authenticity instantly and securely
              </p>

            </div>

            {/* Form */}
            <form
              onSubmit={handleVerifyCard}
              className="verification-form"
            >

              <div className="verification-input-wrapper">

                <CreditCard className="verification-input-icon" />

                <input
                  type="text"
                  placeholder="Enter Customer Card Number"
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                  required
                />

              </div>

              <button
                type="submit"
                className="verify-btn"
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Verify Card'}
              </button>

            </form>

            {/* Verified */}
            {verificationResult?.status === 'verified' && (

              <div className="verification-result success-result">

                <CheckCircle size={70} />

                <h3>Card Verified Successfully</h3>

                <p>
                  This customer card exists in the verification system.
                </p>

                <div className="verified-card-details">

                  <div className="verified-detail-box">
                    <span>Card Number</span>
                    <strong>
                      {verificationResult.data.cardNumber}
                    </strong>
                  </div>

                  <div className="verified-detail-box">
                    <span>Month</span>
                    <strong>
                      {verificationResult.data.cardMonth}
                    </strong>
                  </div>

                  <div className="verified-detail-box">
                    <span>Year</span>
                    <strong>
                      {verificationResult.data.cardYear}
                    </strong>
                  </div>

                </div>

              </div>

            )}

            {/* Not Found */}
            {verificationResult?.status === 'not_found' && (

              <div className="verification-result failed-result">

                <XCircle size={70} />

                <h3>Card Not Found</h3>

                <p>
                  This card number is not available in the system.
                </p>

              </div>

            )}

            {/* Error */}
            {verificationResult?.status === 'error' && (

              <div className="verification-result error-result">

                <XCircle size={70} />

                <h3>Verification Failed</h3>

                <p>
                  Something went wrong while verifying the card.
                </p>

              </div>

            )}

          </div>

        </div>

      )}











{/********************************************** customer directory ******************************************************/}


{activeTab === "membershipSubmission" && (
  <div className="membership-submission-container">
    <h2>Membership Submission</h2>

    {memberships.length === 0 ? (
      <p>No records found.</p>
    ) : (
      <table className="membership-table">
        <thead>
          <tr>
            <th>Institution Name</th>
            <th>Position</th>
            <th>Qualification</th>
            <th>Address</th>
            <th>Contact Address</th>
            <th>District</th>
            <th>Province</th>
            <th>Divisional Secretary</th>
            <th>Contact Person</th>
            <th>Contact Phone</th>
            <th>Telephone</th>
            <th>Email</th>
            <th>Website</th>
            <th>BR No</th>
            <th>Established Date</th>
            <th>Created At</th>

            {/* Institution Type */}
            <th>Retail Optical</th>
            <th>Wholesale</th>
            <th>Investor</th>
            <th>Other</th>
            <th>Other Specify</th>

            {/* Amenities */}
            <th>Kids Area</th>
            <th>Parking</th>
            <th>Restroom</th>
            <th>Waiting Area</th>
            <th>Wheelchair Access</th>
            <th>Wi-Fi</th>

            {/* Amenities Details */}
            <th>Kids Area Details</th>
            <th>Parking Details</th>
            <th>Restroom Details</th>
            <th>Waiting Area Details</th>
            <th>Wheelchair Access Details</th>
            <th>Wi-Fi Details</th>

            {/* Infrastructure */}
            <th>Auto Refractometer</th>
            <th>Edger</th>
            <th>Lensometer</th>
            <th>Manual Edger</th>
            <th>Patternless Edger</th>
            <th>Phoropter</th>
            <th>Slit Lamp</th>
            <th>Trial Set</th>

            {/* Infrastructure Details */}
            <th>Auto Refractometer Details</th>
            <th>Edger Details</th>
            <th>Lensometer Details</th>
            <th>Manual Edger Details</th>
            <th>Patternless Edger Details</th>
            <th>Phoropter Details</th>
            <th>Slit Lamp Details</th>
            <th>Trial Set Details</th>
          </tr>
        </thead>

        <tbody>
          {memberships.map((item) => (
            <tr key={item.id}>
              {/* Basic Info */}
              <td>{item.institutionName}</td>
              <td>{item.position}</td>
              <td>{item.qualification}</td>
              <td>{item.address}</td>
              <td>{item.contactAddress}</td>
              <td>{item.district}</td>
              <td>{item.province}</td>
              <td>{item.divisionalSecretary}</td>
              <td>{item.contactPerson}</td>
              <td>{item.contactPhone}</td>
              <td>{item.telephone}</td>
              <td>{item.email}</td>
              <td>{item.website || "-"}</td>
              <td>{item.brNo}</td>
              <td>{item.establishedDate}</td>
              <td>
                {item.createdAt?.toDate
                  ? item.createdAt.toDate().toLocaleDateString()
                  : "-"}
              </td>

              {/* Institution Type */}
              <td>{item.institutionType?.retailOptical ? "Yes" : "No"}</td>
              <td>{item.institutionType?.wholesale ? "Yes" : "No"}</td>
              <td>{item.institutionType?.investor ? "Yes" : "No"}</td>
              <td>{item.institutionType?.other ? "Yes" : "No"}</td>
              <td>{item.institutionType?.otherSpecify || "-"}</td>

              {/* Amenities Available */}
              <td>{item.amenities?.["Kids Area"]?.available ? "Yes" : "No"}</td>
              <td>{item.amenities?.Parking?.available ? "Yes" : "No"}</td>
              <td>{item.amenities?.Restroom?.available ? "Yes" : "No"}</td>
              <td>{item.amenities?.["Waiting Area"]?.available ? "Yes" : "No"}</td>
              <td>{item.amenities?.["Wheelchair Access"]?.available ? "Yes" : "No"}</td>
              <td>{item.amenities?.["Wi-Fi"]?.available ? "Yes" : "No"}</td>

              {/* Amenities Details */}
              <td>{item.amenities?.["Kids Area"]?.details || "-"}</td>
              <td>{item.amenities?.Parking?.details || "-"}</td>
              <td>{item.amenities?.Restroom?.details || "-"}</td>
              <td>{item.amenities?.["Waiting Area"]?.details || "-"}</td>
              <td>{item.amenities?.["Wheelchair Access"]?.details || "-"}</td>
              <td>{item.amenities?.["Wi-Fi"]?.details || "-"}</td>

              {/* Infrastructure Status */}
              <td>{item.infrastructure?.["Auto Refractometer"]?.status}</td>
              <td>{item.infrastructure?.Edger?.status}</td>
              <td>{item.infrastructure?.Lensometer?.status}</td>
              <td>{item.infrastructure?.["Manual Edger"]?.status}</td>
              <td>{item.infrastructure?.["Patternless Edger"]?.status}</td>
              <td>{item.infrastructure?.Phoropter?.status}</td>
              <td>{item.infrastructure?.["Slit Lamp"]?.status}</td>
              <td>{item.infrastructure?.["Trial Set"]?.status}</td>

              {/* Infrastructure Details */}
              <td>{item.infrastructure?.["Auto Refractometer"]?.details || "-"}</td>
              <td>{item.infrastructure?.Edger?.details || "-"}</td>
              <td>{item.infrastructure?.Lensometer?.details || "-"}</td>
              <td>{item.infrastructure?.["Manual Edger"]?.details || "-"}</td>
              <td>{item.infrastructure?.["Patternless Edger"]?.details || "-"}</td>
              <td>{item.infrastructure?.Phoropter?.details || "-"}</td>
              <td>{item.infrastructure?.["Slit Lamp"]?.details || "-"}</td>
              <td>{item.infrastructure?.["Trial Set"]?.details || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}

{/************************************************ add Customer Card ****************************************************************************/}




      {activeTab === "addCustomerCard" && (
        <div className="add-customer-card-container">

          <h2>Add Customer Card</h2>

          {successMessage && (
            <p className="success-message">{successMessage}</p>
          )}

          {errorMessage && (
            <p className="error-message">{errorMessage}</p>
          )}

          <form onSubmit={handleSaveCard} className="customer-card-form">

            {/* Card Number */}
            <div className="form-group">
              <label>Card Number</label>
              <input
                type="text"
                placeholder="Enter Card Number"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                required
              />
            </div>

            {/* Card Month */}
            <div className="form-group">
              <label>Card Month</label>
              <select
                value={cardMonth}
                onChange={(e) => setCardMonth(e.target.value)}
                required
              >
                <option value="">Select Month</option>

                {[
                  'January',
                  'February',
                  'March',
                  'April',
                  'May',
                  'June',
                  'July',
                  'August',
                  'September',
                  'October',
                  'November',
                  'December'
                ].map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>

            {/* Card Year */}
            <div className="form-group">
              <label>Card Year</label>
              <select
                value={cardYear}
                onChange={(e) => setCardYear(e.target.value)}
                required
              >
                <option value="">Select Year</option>

                {Array.from({ length: 10 }, (_, i) => 2026 + i).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <button type="submit" className="save-card-btn">
              Save Customer Card
            </button>

          </form>
        </div>
      )}















{/****************************************************************************************************************************/}



  {activeTab === "viewCustomerCard" && (

        <div className="view-customer-card-container">

          <h3>View Customer Cards</h3>

          {/* Filters */}
          <div className="customer-card-filters">

            {/* Month Filter */}
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <option value="">All Months</option>

              {[
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
              ].map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>

            {/* Year Filter */}
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="">All Years</option>

              {Array.from({ length: 10 }, (_, i) => 2026 + i).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>

          </div>

          {/* Table */}
          <div className="customer-card-table-wrapper">

            <table className="customer-card-table">

              <thead>
                <tr>
                  <th>#</th>
                  <th>Card Number</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Created Date</th>
                </tr>
              </thead>

              <tbody>

                {filteredCards.length > 0 ? (

                  filteredCards.map((card, index) => (

                    <tr key={card.id}>

                      <td>{index + 1}</td>

                      <td>{card.cardNumber}</td>

                      <td>{card.cardMonth}</td>

                      <td>{card.cardYear}</td>

                      <td>
                        {card.createdAt?.toDate
                          ? card.createdAt.toDate().toLocaleString()
                          : 'N/A'}
                      </td>

                    </tr>

                  ))

                ) : (

                  <tr>
                    <td colSpan="5" className="no-data">
                      No customer cards found
                    </td>
                  </tr>

                )}

              </tbody>

            </table>

          </div>

        </div>

      )}

{/******************************************************************************************************************************/}



      </div>
    </div>
  );
}



export default SubAdminPanel